module.exports = "/fast-coin/img/coin/anim/in/coin_in_012.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_012.png
// module id = 2282
// module chunks = 5